import { FC } from 'react';

interface BitSelectorProp {
  isTrue: boolean;
  onClick: (isTrue: boolean) => void;
  leftText: string;
  rightText: string;
  title?: string;
}

const BitSelector: FC<BitSelectorProp> = ({ isTrue, onClick, leftText, rightText, title }) => {
  return (
    <div className="p-4">
      {title && (
        <span className="block mb-3 text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          {title}
        </span>
      )}
      <div className="flex p-1 bg-gray-100 dark:bg-slate-700/50 rounded-xl">
        <button
          onClick={() => onClick(true)}
          className={`flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
            isTrue
              ? 'bg-white dark:bg-slate-600 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          {leftText}
        </button>
        <button
          onClick={() => onClick(false)}
          className={`flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
            !isTrue
              ? 'bg-white dark:bg-slate-600 text-gray-900 dark:text-white shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          {rightText}
        </button>
      </div>
    </div>
  );
};

export default BitSelector;
